export const tableConfigProspekToday = [
  {
    name: "totalNonFollowup",
    label: "NON FU",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "50%", minWidth: "50%", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { width: "50%", minWidth: "50%", textAlign: "center" },
      }),
    },
  },
  {
    name: "totalOngoing",
    label: "ON GOING",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "50%", minWidth: "50%", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { width: "50%", minWidth: "50%", textAlign: "center" },
      }),
    },
  },
];

export const tableConfigAppointmentFUToday = [
  {
    name: "name",
    label: "Nama Konsumen",
    options: {
      setCellHeaderProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "address",
    label: "Alamat",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "kecamatan",
    label: "Kecamatan",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "hpNumber1",
    label: "Nomor HP 1",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "hpNumber2",
    label: "Nomor HP 2",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
];

export const tableConfigAppointmentOverdue = [
  {
    name: "name",
    label: "Nama Konsumen",
    options: {
      setCellHeaderProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "address",
    label: "Alamat",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "kecamatan",
    label: "Kecamatan",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "hpNumber1",
    label: "Nomor HP 1",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "hpNumber2",
    label: "Nomor HP 2",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "overdue",
    label: "Overdue",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
];
